import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {accountSearchResultStateSelector} from './account-search-result-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountPrimaryManager} from 'src/openapi/admin/models/AccountPrimaryManager';
import type {AccountSearchCriteria} from 'src/openapi/admin/models/AccountSearchCriteria';
import type {AccountSearchFiltering} from 'src/openapi/admin/models/AccountSearchFiltering';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';

export const accountSearchResultPrimaryManagerSlice = getCachedTableDataSlice<
    Record<string, AccountPrimaryManager>,
    AccountSearchCriteria,
    AccountSortField,
    AccountSearchFiltering
>('accountSearchResultPrimaryManager');

export const accountSearchResultPrimaryManagerActions = accountSearchResultPrimaryManagerSlice.actions;

const accountSearchResultPrimaryManagerCacheSelector: CachedTableCacheSelector<Record<string, AccountPrimaryManager>>
    = state => state.accountSearchResult.primaryManager.cache;
export const accountSearchResultPrimaryManagerDataSelector: CachedTableDataSelector<
    Record<string, AccountPrimaryManager>
> = state => state.accountSearchResult.primaryManager;
export const accountSearchResultPrimaryManagerResultSelector = getCachedTableResultSelector(
    accountSearchResultPrimaryManagerCacheSelector,
    accountSearchResultStateSelector,
);
